import { Component, Input } from '@angular/core';
import { MyRouter } from '../../../common/services/router.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-nav-footer',
    templateUrl: './nav-footer.component.html',
    styleUrls: ['./nav-footer.component.scss']
})
export class NavFooterComponent {
    @Input() allowedToOrder$: Observable<boolean>;

    constructor(private router: MyRouter) {
    }

    navigateTo(url: string[]) {
        this.router.navigateWithCorporateClient(url);
    }

}
